import { formatDate } from "../formating";
import { normalizePhone, normalizeString } from "../functions";

const employeeSchema = {
  // COMMENTED OUT UNTIL WE DISCUSS ADDING MORE USER INFO
  //   phone: phone => normalizePhone(phone),
  //   birthdayDay: day => Number(day),
  //   birthdayMonth: month => month,
  //   birthdayYear: year => Number(year),
  email: (email) => normalizeString({ data: email, actions: ["spacing"] }),
  workEmail: (email) => normalizeString({ data: email, actions: ["spacing"] }),
  firstName: (firstName) =>
    normalizeString({ data: firstName, actions: ["spacing"] }),
  lastName: (lastName) =>
    normalizeString({ data: lastName, actions: ["spacing"] }),
  phone: (phone) => normalizePhone(phone),
  city: (city) => normalizeString({ data: city, actions: ["spacing"] }),
  state: (state) => normalizeString({ data: state, actions: ["spacing"] }),
  zip: (zip) => zip,
  country: (country) => "US",
  addressLine1: (addressLine1) =>
    normalizeString({ data: addressLine1, actions: ["spacing"] }),
  addressLine2: (addressLine2) =>
    normalizeString({ data: addressLine2, actions: ["spacing"] }),
  dateOfBirth: (dob) =>
    formatDate({
      actions: ["mysql"],
      data: dob,
    }),
  socialSecurityNumber: (socialSecurityNumber) => {
    const formatted = socialSecurityNumber.replace(/-/g, "");
    return formatted;
  },

  isOneClick: (isOneClick) => isOneClick,
  checkoutSessionId: (checkoutSessionId) => checkoutSessionId,
  cancel: (cancel) => cancel,

  isHsaRecentActivity: (isHsaRecentActivity) => isHsaRecentActivity === "Yes",
  isExistingHsa: (isExistingHsa) => isExistingHsa === "Yes",
  taxFilingStatus: (taxFilingStatus) => taxFilingStatus,

  payrollId: (payrollId) => payrollId,
  employerHraGroupId: (employerHraGroupId) => employerHraGroupId,
  createHsa: (createHsa) => createHsa,
  hraMonthlyAllowance: (hraMonthlyAllowance) => Number(hraMonthlyAllowance),
  hraStartDate: (hraStartDate) => hraStartDate,
  employment: (employment) => employment,
  hsaContribution: (hsaContribution) => hsaContribution,
};

export default employeeSchema;
